import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { Spinner } from '@bibliocommons/base-icons';
import { bibShape, checkedOutItemShape } from '@bibliocommons/bc-prop-types';
import { ModalHeader, ModalContent, ModalFooter } from 'app/components/shared/Modal';
import { selectFulfilmentData } from 'app/selectors/CheckoutSelector';

import './FulfilmentContent.scss';

export default function FulfilmentContent({ bib, accountId, checkoutActions, checkoutItem }) {
  const intl = useIntl();
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const fulfilment = useSelector(selectFulfilmentData);
  const checkoutId = checkoutItem.get('checkoutId');
  const title = bib.getIn(['briefInfo', 'title']);

  useEffect(() => {
    checkoutActions.getFulfilment({ checkoutId, accountId });
  }, [checkoutId, accountId, checkoutActions]);

  return (
    <div className="cp-fulfilment-content">
      <ModalHeader title={<FormattedMessage id="access_this_item" />} />
      <ModalContent>
        {fulfilment.get('fetching') || !iframeLoaded ? (
          <div className="loading">
            <Spinner primary />
          </div>
        ) : null}
        {!fulfilment.get('fetching') && fulfilment.get('url') ? (
          <iframe
            src={fulfilment.get('url')}
            frameBorder="0"
            allowFullScreen
            onLoad={() => setIframeLoaded(true)}
            title={intl.formatMessage({ id: 'access_title' }, { title })}
            data-key="fulfilment-iframe"
          />
        ) : null}
      </ModalContent>
      <ModalFooter
        renderPrimaryAction={() => null}
        secondaryActionButtonText={<FormattedMessage id="button_close" />}
      />
    </div>
  );
}

FulfilmentContent.propTypes = {
  bib: bibShape.isRequired,
  accountId: PropTypes.number.isRequired,
  checkoutItem: checkedOutItemShape.isRequired,
  checkoutActions: PropTypes.objectOf(PropTypes.func).isRequired
};
